import type { FaireProductEntity } from "../../entity_types/product";

export const p_qyenz7qrvm: FaireProductEntity = {
  token: "p_qyenz7qrvm",
  type: "product",
  name: "Oval-Cut Moissanite Engagement Ring in 925 Sterling Silver",
  brandToken: "b_xd955m9fpf",
  brandName: "Perimade & Co. LLC",
  imageUrl:
    "https://cdn.faire.com/fastly/43820319e12e0e74f1a7675830dd322e9230445c40b6a2ab508afbb3df5aada1.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/0951b4b3ad17282afac76f65faf7674b8f41437b5604facc06fe4c4cd50e22db.jpeg",
    "https://cdn.faire.com/fastly/62383926b6d6179e097bc41d3821aff90b2278bcec703a676a1f8fd6c31cf6c1.png",
    "https://cdn.faire.com/fastly/1e61d380985a45423c96871cd2a8d4617087c53dc566f3bb6f5343918402c6ee.jpeg",
    "https://cdn.faire.com/fastly/2bc512b0aa7d013c61c4cb3766e0ec2cbf9c37c8352fd15c6bfed897bee0e346.jpeg",
    "https://cdn.faire.com/fastly/ef2b610da9860a22ccb693c65ac456c3ae21e538a7bae8aa1390620aad5caf78.jpeg",
    "https://cdn.faire.com/fastly/22799e9f43b9ea91ec79c55ffb961c716384f58b27a7107be5612ce06a1fd035.jpeg",
    "https://cdn.faire.com/fastly/0dab8e6ad5bfbd2e119741586c73e64fbb0e5c79e7a4947b2560157cdb066a94.jpeg",
  ],
  priceDollars: 35.99,
  description:
    "Description & Details\n\nExperience the brilliance and beauty of this exceptional gemstone. Each piece in our collection is meticulously crafted to showcase the mesmerizing sparkle and fire of moissanite, offering a stunning alternative to traditional diamond jewelry.\n\n• Material: Solid 925 Sterling Silver ∙ Certified Moissanite (Color D, VVS1)\n• Finish: Hypoallergenic ∙ 950 Platinum (Pt 950) Plating\n• Dimensions: 1.0 - 2.0 ct, Color D, VVS1 Moissanite, US size 5 - 9 available\n• All our work is custom made by hand with love",
  tags: [],
  msrpDollars: 59.52,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:59:01.140Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
